<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36" height="27" viewBox="0 0 36 27">
  <defs>
    <filter id="Path_12" x="0" y="0" width="36" height="14.983" filterUnits="userSpaceOnUse">
      <feOffset input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="1.5" result="blur"/>
      <feFlood flood-opacity="0.596"/>
      <feComposite operator="in" in2="blur"/>
      <feComposite in="SourceGraphic"/>
    </filter>
    <filter id="Rectangle_125" x="0" y="5.983" width="36" height="15.12" filterUnits="userSpaceOnUse">
      <feOffset input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="1.5" result="blur-2"/>
      <feFlood flood-opacity="0.596"/>
      <feComposite operator="in" in2="blur-2"/>
      <feComposite in="SourceGraphic"/>
    </filter>
    <filter id="Path_13" x="0" y="11.994" width="36" height="15.006" filterUnits="userSpaceOnUse">
      <feOffset input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="1.5" result="blur-3"/>
      <feFlood flood-opacity="0.596"/>
      <feComposite operator="in" in2="blur-3"/>
      <feComposite in="SourceGraphic"/>
    </filter>
  </defs>
  <g id="russia" transform="translate(4.5 -83.776)">
    <g transform="matrix(1, 0, 0, 1, -4.5, 83.78)" filter="url(#Path_12)">
      <path id="Path_12-2" data-name="Path 12" d="M24.978,88.276H2.022A2.037,2.037,0,0,0,0,90.328v3.931H27V90.328A2.037,2.037,0,0,0,24.978,88.276Z" transform="translate(4.5 -83.78)" fill="#fff"/>
    </g>
    <g transform="matrix(1, 0, 0, 1, -4.5, 83.78)" filter="url(#Rectangle_125)">
      <rect id="Rectangle_125-2" data-name="Rectangle 125" width="27" height="6.12" transform="translate(4.5 10.48)" fill="#0039a6"/>
    </g>
    <g transform="matrix(1, 0, 0, 1, -4.5, 83.78)" filter="url(#Path_13)">
      <path id="Path_13-2" data-name="Path 13" d="M0,315.854a2.041,2.041,0,0,0,2.022,2.06H24.978A2.041,2.041,0,0,0,27,315.854v-3.947H0Z" transform="translate(4.5 -295.41)" fill="#d52b1e"/>
    </g>
  </g>
</svg>